<template>
  <div class="submitWrapper paddBottom">
    <IndexHeaderOthers ref="indexHeader"></IndexHeaderOthers>
    <div class="main">
      <div class="conner">
        <div class="listData">
          <el-descriptions class="margin-top" :column="1" size="small" border>
            <el-descriptions-item
              v-for="(item, index) in ListData"
              :key="index"
            >
              <template slot="label">
                {{ item.label }}
              </template>
              {{ NoticequeryById[item.name] }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
			<!-- <div v-html="NoticequeryById.content"></div> -->
			<pre class="desc">{{NoticequeryById.content}}</pre>
			<div class="desc2">
				SOURCE：{{NoticequeryById.detailUrl}}
			</div>
        <Message :titles="titles" @getInfo="getInfos"></Message>
      </div>
    </div>
  </div>
</template>
<script>
import IndexHeaderOthers from "../../components/header/indexHeaderOthers.vue";
import Message from "../../components/page/Message";
export default {
  name: "noticeIndex",
  components: { IndexHeaderOthers, Message },
  data() {
    return {
		titles:'Notice',
      ListData: [
        {
          label: "TITLE:",
          name: "title",
        },
		{
		  label: "NOTICE TYPE:",
		  name: "noticeType",
		},
		{
		  label: "NOTICE DATE",
		  name: "noticeDate",
		},
        // {
        //   label: "THETA:",
        //   name: "theta",
        // },
        
        // {
        //   label: "PHI:",
        //   name: "",
        // },
        // {
        //   label: "SC_Lat: ",
        //   name: "",
        // },
        // {
        //   label: "SATELLITE: ",
        //   name: "",
        // },
        // {
        //   label: "SC_Long: ",
        //   name: "",
        // },
        // {
        //   label: "TRIGGER_ID: ",
        //   name: "",
        // },
        // {
        //   label: "SUN_RA: ",
        //   name: "",
        // },
        // {
        //   label: "TRIGGER UID: ",
        //   name: "",
        // },
        // {
        //   label: "SUN_DEC: ",
        //   name: "",
        // },
        // {
        //   label: "TRIGGER_DATE: ",
        //   name: "",
        // },
        // {
        //   label: "SUN_DIST: ",
        //   name: "sunDist",
        // },
        // {
        //   label: "TRIGGER TIME: ",
        //   name: "triggerTime",
        // },
        // {
        //   label: "MOON RA: ",
        //   name: "",
        // },
        // {
        //   label: "TRIGGER_SIGNIF ",
        //   name: "triggerSignif",
        // },
        // {
        //   label: "MOON_DEC ",
        //   name: "",
        // },
        // {
        //   label: "TRIG_RA ",
        //   name: "",
        // },
        // {
        //   label: "MOON_DIST ",
        //   name: "moonDist",
        // },
        // {
        //   label: "TRIG_DEC ",
        //   name: "",
        // },
        // {
        //   label: "GAL_LON ",
        //   name: "",
        // },
        // {
        //   label: "TRIG_ERROR ",
        //   name: "",
        // },
        // {
        //   label: "GAL_LAT ",
        //   name: "",
        // },
        // {
        //   label: "CLASS ",
        //   name: "",
        // },
        // {
        //   label: "COMMENTS ",
        //   name: "comments",
        // },
        // {
        //   label: "SRC NAME ",
        //   name: "",
        // },
        // {
        //   label: "",
        // },
      ],
      NoticequeryById: [],
      id: this.$route.query.id,
    };
  },
  methods: {
    //Notice详情列表
    getNoticequeryById() {
      const param = { id: this.id };
      this.$fetchGet("/cms-middle/astronNotice/queryById", param).then(
        (res) => {
          this.NoticequeryById = res.astronNotice;
		  this.NoticequeryById.noticeDate = this.format(this.NoticequeryById.noticeDate)
        }
      );
    },
	format(date){
	   var date = new Date(date);
	   var Y = date.getFullYear() + '-';
	   var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
	   var D = date.getDate() + ' ';
	   var h = (date.getHours() < 10 ? '0' + (date.getHours()) : date.getHours()) + ':';
	   var m = (date.getMinutes() < 10 ? '0' + (date.getMinutes()) : date.getMinutes()) + ':';
	   var s = (date.getSeconds() < 10 ? '0' + (date.getSeconds()) : date.getSeconds());
	   var a = Y+M+D+h+m+s; 
	    return a; 
	},
	getInfos(e){
		this.id = e.id
		this.getNoticequeryById()
	}
  },
  mounted() {
	  this.getNoticequeryById()
	  this.$route.meta.title = localStorage.getItem('metaTitle')
    // window.addEventListener("scroll", this.$refs.indexHeader.scrollToTop, true);
  },
};
</script>
<style scoped>
.main {
  position: relative;
  margin-top: -70px;
  z-index: 99;
  width: 100%;
  height: auto;
  background: #fff;
  border-radius: 0 120px 0 0;
}

.conner {
  width: 1050px;
  margin: 0 auto;
  text-align: left;
}

.listData {
  padding-top: 30px;
}
.desc {
	border-top: 2px solid #008dc9;
	margin-top: 22px;
	/* height: 410px; */
	background: #f7f9fb;
	padding: 12px;
	padding-bottom: 0;
}
pre{
	margin-bottom: 0;
	word-wrap: break-word;
	white-space: pre-wrap;
}
.desc2 {
	/* height: 410px; */
	background: #f7f9fb;
	padding: 12px;
	font-size: 14px;
}

.desc p {
	margin: 25px 32px;
	font-size: 14px;
	font-family: Alibaba Sans;
	font-weight: 500;
	color: #333333;
	line-height: 23px;
}

.desc p:first-child {
	margin-top: 44px;
}
</style>
